"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRGB = void 0;
function hexToRGB(h, opacity) {
    h = h.replace('#', '');
    let r = 0, g = 0, b = 0;
    if (h.length === 3) {
        r = Number(`0x${h[0]}${h[0]}`);
        g = Number(`0x${h[1]}${h[1]}`);
        b = Number(`0x${h[2]}${h[2]}`);
    }
    else if (h.length === 6) {
        r = Number(`0x${h[0]}${h[1]}`);
        g = Number(`0x${h[2]}${h[3]}`);
        b = Number(`0x${h[4]}${h[5]}`);
    }
    return `rgba(${r}, ${g}, ${b}, ${opacity === undefined ? 1 : opacity})`;
}
exports.hexToRGB = hexToRGB;
//# sourceMappingURL=hexToRGB.js.map